import { render, staticRenderFns } from "./input-content.vue?vue&type=template&id=1a1d4bea&scoped=true"
import script from "./input-content.vue?vue&type=script&lang=js"
export * from "./input-content.vue?vue&type=script&lang=js"
import style0 from "./input-content.vue?vue&type=style&index=0&id=1a1d4bea&prod&lang=scss&scoped=true"
import style1 from "./input-content.vue?vue&type=style&index=1&id=1a1d4bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d4bea",
  null
  
)

export default component.exports